
import { useState } from "react";
import Layout from "@/components/layout/Layout";
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Plus, Search, Handshake } from "lucide-react";
import ParceiroForm from "@/components/parceiros/ParceiroForm";
import { useToast } from "@/components/ui/use-toast";

const ParceirosPage = () => {
  const [isAddingPartner, setIsAddingPartner] = useState(false);
  const { toast } = useToast();

  const handleAddPartner = () => {
    setIsAddingPartner(true);
  };

  const handleCancel = () => {
    setIsAddingPartner(false);
  };

  const handleSave = () => {
    toast({
      title: "Parceiro cadastrado",
      description: "O parceiro foi cadastrado com sucesso!",
    });
    setIsAddingPartner(false);
  };

  return (
    <Layout>
      <div className="container mx-auto p-6">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div>
              <h1 className="text-3xl font-bold flex items-center">
                <Handshake className="mr-2 h-8 w-8 text-energy-green" />
                Parceiros
              </h1>
              <p className="text-muted-foreground">
                Gerencie os parceiros que realizam vendas e instalações de energia solar
              </p>
            </div>

            <div className="flex gap-2">
              <Button variant="outline" asChild>
                <Link to="/dashboard">
                  Voltar ao Dashboard
                </Link>
              </Button>
              {!isAddingPartner && (
                <Button onClick={handleAddPartner}>
                  <Plus className="h-4 w-4 mr-2" />
                  Novo Parceiro
                </Button>
              )}
            </div>
          </div>

          {isAddingPartner ? (
            <Card>
              <CardHeader>
                <CardTitle>Cadastrar Novo Parceiro</CardTitle>
                <CardDescription>
                  Preencha os dados do novo parceiro integrador solar
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ParceiroForm onCancel={handleCancel} onSave={handleSave} />
              </CardContent>
            </Card>
          ) : (
            <>
              <div className="grid grid-cols-1 gap-4">
                <Card>
                  <CardHeader className="pb-3">
                    <CardTitle>Lista de Parceiros</CardTitle>
                    <CardDescription>
                      Visualize e gerencie os parceiros cadastrados
                    </CardDescription>
                    <div className="relative mt-4">
                      <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
                      <input
                        type="text"
                        placeholder="Buscar parceiros..."
                        className="pl-8 h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                      />
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="text-center py-10 text-muted-foreground">
                      Nenhum parceiro cadastrado. Clique em "Novo Parceiro" para adicionar.
                    </div>
                  </CardContent>
                </Card>
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ParceirosPage;
